import { EventBus } from '@/event-bus'

const CHECK_POLL_MS = 5000
const DISCOVERY_POLL_MS = 10000
const TIMEOUT_MS = 10 * 60 * 1000
const DISCOVERY_STABLE_POLLS = 6

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

async function api(method, path, body) {
  var token = localStorage.getItem('token')
  var res = await fetch(process.env.VUE_APP_API_HOST + path, {
    method,
    headers: { Authorization: token ? ('Bearer ' + token) : '', 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  })
  var json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || 'error')
  return json
}

export function trackChecks(page, users, t) {
  if (!users.length) return
  EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress) => {
    var baseline = {}
    users.forEach(u => { baseline[u.user_id] = u.updated_at })
    var total = users.length
    var subscribed = 0
    var deadline = Date.now() + TIMEOUT_MS

    while (Object.keys(baseline).length && Date.now() < deadline) {
      await sleep(CHECK_POLL_MS)
      var json = await api('POST', '/reporting/boosting/status', { page_id: page.id, user_ids: Object.keys(baseline) }).catch(() => null)
      if (!json) continue
      json.users.forEach(doc => {
        if (!(doc.user_id in baseline) || doc.updated_at === baseline[doc.user_id]) return
        delete baseline[doc.user_id]
        if (doc.status === 'subscribed') subscribed++
        EventBus.$emit('boostingUserChecked', { page_id: page.id, doc })
      })
      var done = total - Object.keys(baseline).length
      onProgress(Math.round(done / total * 100) + '% · ' + t('dash.boosting.tasks.check_progress', { done, total }))
    }

    EventBus.$emit('boostingChecksDone', { page_id: page.id, user_ids: users.map(u => u.user_id), subscribed })
    onSuccess(t('dash.boosting.tasks.check_done', { subscribed, done: total - Object.keys(baseline).length, total }))
  }, {
    title: t('dash.boosting.tasks.check_title', { name: page.name }),
    picture: page.avatar || null,
    loadingText: t('dash.boosting.tasks.check_progress', { done: 0, total: users.length }),
  })
}

export function trackDiscovery(page, t) {
  EventBus.$emit('requestManagerAdd', async (onSuccess, onProgress) => {
    var deadline = Date.now() + TIMEOUT_MS
    var count = null
    var stable = 0

    while (stable < DISCOVERY_STABLE_POLLS && Date.now() < deadline) {
      await sleep(DISCOVERY_POLL_MS)
      var json = await api('GET', '/reporting/boosting/users?page_ids=' + page.id + '&status=pending&size=1').catch(() => null)
      if (!json) continue
      if (json.total === count) {
        stable++
        continue
      }
      stable = 0
      count = json.total
      EventBus.$emit('boostingDiscoveryProgress', { page_id: page.id, total: count })
      onProgress(t('dash.boosting.tasks.discovery_progress', { count }))
    }

    onSuccess(t('dash.boosting.tasks.discovery_done', { count: count || 0 }))
  }, {
    title: t('dash.boosting.tasks.discovery_title', { name: page.name }),
    picture: page.avatar || null,
    loadingText: t('dash.boosting.tasks.discovery_progress', { count: 0 }),
  })
}
